/** Email vs popup builder chrome (sidebar layout). */
export type EditorType = "email" | "popup";

/**
 * Normalize embedder input (`email` / `EMAIL`, `popup` / `POPUP`, etc.).
 * Unknown values fall back to `email`.
 */
export function normalizeEditorType(
  raw?: string | EditorType | null,
): EditorType {
  if (raw === undefined || raw === null) return "email";
  const n = String(raw).trim().toLowerCase();
  if (n === "popup") return "popup";
  return "email";
}
